<template>
  <generic-modal :title="$t('event')" ref="generic_modal">
    <div class="form">
      <div class="columns">
        <div class="column is-4">
          <div class="field">
            <label for="" class="label">{{ $t("color") }}</label>
            <div class="control">
              <div class="select">
                <select v-model="meta.settings.color">
                  <option value="rgb(0, 209, 178)">{{ $t("teal") }}</option>
                  <option value="rgb(66, 88, 255)">{{ $t("blue") }}</option>
                  <option value="rgb(102, 209, 255);">
                    {{ $t("light blue") }}
                  </option>
                  <option value="rgb(72, 199, 142)">{{ $t("green") }}</option>
                  <option value="rgb(255, 183, 15)">{{ $t("yellow") }}</option>
                  <option value="rgb(255, 102, 133)">{{ $t("red") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.settings.name" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("start date") }}</label>
            <generic-calendar
              type="datetime"
              ref="start_date_calendar"
              display_mode="dialog"
              @selected="start_date_changed"
            />
          </div>
          <div class="field">
            <label class="label">{{ $t("end date") }}</label>
            <generic-calendar
              type="datetime"
              ref="end_date_calendar"
              display_mode="dialog"
              @selected="end_date_changed"
            />
          </div>
        </div>
        <!-- <div class="column"></div> -->
      </div>
      <div class="field">
        <input
          class="is-checkradio"
          type="checkbox"
          id="chk_is_public"
          v-model="meta.is_public"
        />
        <label for="chk_is_public">{{ $t("is public") }}</label>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import moment from "moment";

export default {
  name: "EventModal",
  components: { GenericModal, GenericCalendar },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.settings.name || !v.meta.start_date || !v.meta.end_date;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    create_event(args) {
      let v = this;
      v.set_initial_state();
      v.$refs.start_date_calendar.set_date(args.date);
      v.meta.start_date = args.date;
      let end_date = moment(args.date).add(1, "hour");
      v.$refs.end_date_calendar.set_date(end_date);
      v.meta.end_date = end_date;
      v.$refs.generic_modal.show_modal();
    },
    edit_event(event_uuid) {
      let v = this;
      v.set_initial_state();

      if (event_uuid) {
        // v.uuid = product_uuid;
        get("/calendar/event", { uuid: event_uuid })
          .then((event) => {
            v.meta = event;
            if (event.start_date) {
              v.$refs.start_date_calendar.set_date(event.start_date);
              v.meta.start_date = moment(event.start_date);
            }
            if (event.end_date) {
              v.$refs.end_date_calendar.set_date(event.end_date);
              v.meta.end_date = moment(event.end_date);
            }

            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/calendar/event", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/calendar/event", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        start_date: null,
        end_date: null,
        settings: {
          name: "",
        },
      };
      v.error = "";
      // v.uuid = "";
    },
    start_date_changed(date) {
      let v = this;
      v.meta.start_date = date;
    },
    end_date_changed(date) {
      let v = this;
      v.meta.end_date = date;
    },
    remove() {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete event?"), v, () => {
        del("/calendar/event", { uuid: v.meta.uuid })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
